"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ComponentBase_1 = require("./ComponentBase");

var CustomChartBase =
/** @class */
function (_super) {
  __extends(CustomChartBase, _super);

  function CustomChartBase() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Object.defineProperty(CustomChartBase.prototype, "legendProps", {
    get: function get() {
      var result;
      var legend = this.props.legend;

      if (legend && legend.show) {
        var items = legend.items || this.getLegendItems();
        result = __assign(__assign({}, legend), {
          items: items
        });
      }

      return result;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CustomChartBase.prototype, "legendPosition", {
    get: function get() {
      var legend = this.props.legend;

      if (legend && legend.show && legend.position) {
        return legend.position;
      }

      return 'bottom';
    },
    enumerable: true,
    configurable: true
  });
  return CustomChartBase;
}(ComponentBase_1.ComponentBase);

exports.CustomChartBase = CustomChartBase;